"use client"

import {Button} from "@/theme/ui";
import {useRouter} from "next/navigation";
import {ArrowLeftIcon} from "@/theme/assets/icons";
import {useLocale} from "next-intl";

export const BackButton = ({type= 'text', children = 'Back', link = null, ...rest}) => {
    const router = useRouter();
    const locale = useLocale();
    const languages = [
        {
            title: 'Chinese',
            value: 'CN',
            key: 'cn',
            icon: '/icon/flag/Language=CN.svg'
        },
        {
            title: 'English',
            value: 'En',
            key: 'en',
            icon: '/icon/flag/Language=US.svg'
        },
        {
            title: 'French',
            value: 'FR',
            key: 'fr',
            icon: '/icon/flag/Language=FR.svg'
        },
        {
            title: 'German',
            value: 'DE',
            key: 'de',
            icon: '/icon/flag/Language=DE.svg'
        },
        {
            title: 'Italian',
            value: 'IT',
            key: 'it',
            icon: '/icon/flag/Language=IT.svg'
        },
        {
            title: 'Polish',
            value: 'PL',
            key: 'pl',
            icon: '/icon/flag/Language=PL.svg'
        },
        {
            title: 'Romanian',
            value: 'RO',
            key: 'ro',
            icon: '/icon/flag/Language=RO.svg'
        },
        {
            title: 'Russian',
            value: 'RU',
            key: 'ru',
            icon: '/icon/flag/Language=RU.svg'
        },
        {
            title: 'Spanish',
            value: 'ES',
            key: 'es',
            icon: '/icon/flag/Language=ES.svg'
        },
        {
            title: 'Turkish',
            value: 'TR',
            key: 'tr',
            icon: '/icon/flag/Language=TR.svg'
        },
        {
            title: 'Ukrainian',
            value: 'UA',
            key: 'ua',
            icon: '/icon/flag/Language=UA.svg'
        }
    ]

    const goBack = () => {
        const regex = new RegExp(`^/(${languages.map(l => l.key).join('|')})`)
        const cleanedPathname = link.replace(regex, '') // Remove the current locale
        router.push(`/${locale}${cleanedPathname}`)
        // let formated_link = locale !== 'en' ? '/' + locale + link : link;
        // router.push(formated_link);
    }

    return (
        <>
            <Button
                icon={<ArrowLeftIcon />}
                type={type}
                children={children}
                onClick={goBack}
                {...rest}
            />
        </>
    );
}